<template>
  <div class="content" :style="minHeightStyle">
    <img src="/static/qa_banner.png" class="banner" alt>
    <a :href="'tel:'+servicePhone">
      <div class="phone-bnt">
        <i class="iconfont icon-service" style="font-size: 16px;"></i> 7 x 12 小时客服热线
      </div>
    </a>
    <div class="qa-item">
      <div class="qa-title">
        <img src="/static/ico_A.png">
        <div>收到“校圆通”的取件通知，如果当天没空取件，第二天取件需不需要缴费？</div>
      </div>
      <div class="qa-content">
        <img src="/static/ico_Q.png">
        <div>
          <p>快递如果超过三天不取，我们可能会原路退回给快递公司，所以还是请大家收到取件通知后尽量当天取走，如果实在没空可以叫朋友代取，您也可以体验一下我们的有偿送件上门服务，超时取件是否收费可致电所在网点咨询详情。</p>
        </div>
      </div>
    </div>
    <div class="qa-item">
      <div class="qa-title">
        <img src="/static/ico_A.png">
        <div>物流信息显示在派送中或者已签收但是没有收到“校圆通”的取件通知？</div>
      </div>
      <div class="qa-content">
        <img src="/static/ico_Q.png">
        <div>
          <p>（1）如果物流信息显示的是“派件中”，有可能是上级网点还没有把这个件送到快递中心，也有可能是刚送到我们快递中心，但是快递中心处于派件高峰期，暂时还没有人手上架并给大家发取件通知，上述两种情况请大家耐心等待。</p>
          <p>（2）如果物流信息显示的是“已签收”，有可能是上级网点送件到快递中心的时候漏了您的件，也有可能是我们快递中心给您发送取件通知的时候手误把您的手机号码输错了，上述两种情况请大家凭物流单号到快递服务中心咨询相关工作人员，我们会第一时间给您解决问题。</p>
          <p>PS：我们对快递公司是有送件时间要求的，如果超时未送，我们会催快递公司尽快送过来，如果是情况（2），我们会加派人手，尽快给大家发送取件通知。</p>
        </div>
      </div>
    </div>
    <div class="qa-item">
      <div class="qa-title">
        <img src="/static/ico_A.png">
        <div>为什么取件通知里的快递单号跟物流信息上显示的物流单号不一致？</div>
      </div>
      <div class="qa-content">
        <img src="/static/ico_Q.png">
        <div>
          <p>取件通知里的快递单号正常情况下显示的应该是您的快递的物流单号，如果不一致，应该是快递服务中心工作人员在做入库处理的时候没注意把快递面单上的其他信息当做快递单号录入系统导致，这个不影响您的正常取件请放心。</p>
        </div>
      </div>
    </div>
    <div class="qa-item">
      <div class="qa-title">
        <img src="/static/ico_A.png">
        <div>为什么取件通知里的快递公司跟物流信息上显示负责给我配送的快递公司不一致？</div>
      </div>
      <div class="qa-content">
        <img src="/static/ico_Q.png">
        <div>
          <p>取件通知里的快递公司正常情况下显示的应该是负责给您配送的快递公司，如果不一致，应该是快递服务中心工作人员在做入库处理的时候没注意把其他快递公司录入系统导致，这个不影响您的正常取件请放心。</p>
        </div>
      </div>
    </div>
    <div class="qa-item">
      <div class="qa-title">
        <img src="/static/ico_A.png">
        <div>我已经取走快递，为什么待取件列表里还有这个快递的信息？</div>
      </div>
      <div class="qa-content">
        <img src="/static/ico_Q.png">
        <div>
          <p>因为我们虽然把快递拿给你了，但是取件高峰期或者其他较忙的时间段，为了节省大家的排队时间，我们快递中心服务人员只把快递件给到您，还没来得及把您的快递件做出库处理，所以您在待取件列表中还能看到这个快递件的信息，我们工作人员会尽快把您的这个快递件做出库处理，之后您在待取件列表里就不会再看到它了。</p>
        </div>
      </div>
    </div>
    <div class="qa-item">
      <div class="qa-title">
        <img src="/static/ico_A.png">
        <div>我只有一个快递，为什么会收到多个取件通知？</div>
      </div>
      <div class="qa-content">
        <img src="/static/ico_Q.png">
        <div>
          <p>可能是您当天没有取走您的快递，第二天我们还会发送一个信息提醒您把您的快件取走。</p>
        </div>
      </div>
    </div>
    <div class="qa-item">
      <div class="qa-title">
        <img src="/static/ico_A.png">
        <div>我叫了送件上门服务，怎么没有跑腿把我的件送给我呢？</div>
      </div>
      <div class="qa-content">
        <img src="/static/ico_Q.png">
        <div>
          <p>遇到这种情况的时候不用紧张，可能是因为跑腿单太多导致跑腿工作人员处理订单的时候捡漏了您的件，您的件应该还在快递服务中心，请您拨打上方的客服热线咨询快递服务中心，我们会第一时间帮你解决问题。</p>
        </div>
      </div>
    </div>
    <div class="qa-item">
      <div class="qa-title">
        <img src="/static/ico_A.png">
        <div>快递服务中心有提供兼职么？怎么才能成为快递中心兼职？多少钱一个小时？</div>
      </div>
      <div class="qa-content">
        <img src="/static/ico_Q.png">
        <div>
          <p>我们校园快递服务中心是有提供兼职给到广大学生的，有这方面需求的同学可以直接到我们快递服务中心咨询相关的管理人员了解具体情况。</p>
        </div>
      </div>
    </div>
    <div class="qa-item">
      <div class="qa-title">
        <img src="/static/ico_A.png">
        <div>怎么样才能加入跑腿团队？</div>
      </div>
      <div class="qa-content">
        <img src="/static/ico_Q.png">
        <div>
          <p>为了满足我们的送件上门或者校圆外卖服务，我们组建了学生为主体的校内跑腿团队，想加入我们的跑腿团队的同学可以直接到我们快递服务中心咨询相关的管理人员了解具体情况。</p>
        </div>
      </div>
    </div>
    
    <tab curr="客服" :token="encodeToken"></tab>
  </div>
</template>

<script>
import weui from "weui.js";
import axios from "axios";
import config from "../../config/config";
import Tab from "../home/Tab";

export default {
  components: {
    Tab
  },
  data() {
    return {
      encodeToken: "",
      token: "",
      servicePhone: "",
      minHeightStyle: ""
    };
  },
  created() {
    this.encodeToken = this.$route.params.token;
    this.token = decodeURIComponent(this.encodeToken);
    sessionStorage.setItem("encodeToken", this.encodeToken);
    sessionStorage.setItem("token", this.token);
    axios.defaults.headers["Authorization"] = "Bearer " + this.token;

    this.minHeightStyle = "min-height:" + window.screen.height + "px;";
    this.servicePhone = config.platformServicePhone;

    // 根据token查找微信用户信息
    axios
      .get("/api/user/wxuserInfo")
      .then(response => {
        if (response.data.success) {
          // 获取客服热线
          axios
            .get(
              "/api/worksite/getServicePhoneByTime/" +
                response.data.data.worksite._id
            )
            .then(res => {
              if (res.data.success) {
                this.servicePhone = res.data.data;
              }
            })
            .catch(err => {
              console.log(err);
            });
        }
      })
      .catch(error => {
        weui.topTips("获取用户信息失败", 2000);
      });
  }
};
</script>

<style scoped>
.content {
  background-color: #f1f3f6;
  padding-bottom: 50px;
}
.banner {
  width: 100%;
}
.phone-bnt {
  margin: 10px;
  background-color: #ff9b47;
  border-radius: 4px;
  height: 48px;
  text-align: center;
  color: #ffffff;
  line-height: 48px;
  font-size: 14px;
}
.qa-item {
  margin: 10px;
  padding: 10px;
  background-color: #ffffff;
  border-radius: 4px;
}
.qa-title {
  display: flex;
  position: relative;
}
.qa-title img {
  width: 22px;
  height: 22px;
  margin-right: 10px;
  position: absolute;
  left: 0;
}
.qa-title div {
  font-size: 16px;
  font-weight: bold;
  margin-left: 30px;
}
.qa-content {
  display: flex;
  margin-top: 10px;
  position: relative;
}
.qa-content img {
  width: 22px;
  height: 22px;
  margin-right: 10px;
  position: absolute;
}
.qa-content div {
  font-size: 13px;
  margin-left: 30px;
}
div.tab {
  position: fixed;
  bottom: 0px;
  width: 100%;
}
.grids {
  display: flex;
  flex-wrap: wrap;
  padding-top: 1rem;
  box-shadow: 0 0 15px #cccccc;
}
</style>





// WEBPACK FOOTER //
// src/components/infos/ServiceHelp.vue